import _extends from "@babel/runtime/helpers/esm/extends";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import * as styles from './List.styles';
var ListItemView = styles.ListItemView;

function ListItem(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ListItem'),
      otherProps = _extends({}, _useContextSystem);

  return /*#__PURE__*/React.createElement(ListItemView, Object.assign({}, otherProps, {
    ref: forwardedRef
  }));
}

export default contextConnect(ListItem, 'ListItem');